import { render, staticRenderFns } from "./station-detail-inspection.vue?vue&type=template&id=dee08b7c&scoped=true&"
import script from "./station-detail-inspection.vue?vue&type=script&lang=js&"
export * from "./station-detail-inspection.vue?vue&type=script&lang=js&"
import style0 from "./station-detail-inspection.vue?vue&type=style&index=0&id=dee08b7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee08b7c",
  null
  
)

export default component.exports